import { mergeObjectTypes } from '../cacheHelpers';

const ShipmentsTableLocation = {
  merge: mergeObjectTypes
};

export default ShipmentsTableLocation;
